// import React from "react";
// import { Link } from "react-router-dom";
// import Shape from '../../images/right-arrow-2.svg';

// const ClickHandler = () => {
//     window.scrollTo(10, 0);
// };

// // Projects 2025 – Full Data
// const Projects2025 = [
//     {
//         imgDefault: "https://res.cloudinary.com/dexvxngzg/image/upload/v1764738937/facade_lot_121_option_1_erzo6m.jpg",
//         imgHover: "https://res.cloudinary.com/dexvxngzg/image/upload/v1764738934/facade_lot_121_option_2_p21ecb.jpg",
//         title: "Dreamland 23",
//         subtitle: "Residential Build • 2025",
//         slug: "dreamland-23"
//     },
//     {
//         imgDefault: "https://res.cloudinary.com/dexvxngzg/image/upload/v1765603851/lot_122_option_1_facade_hacz0z.webp",
//         imgHover: "https://res.cloudinary.com/dexvxngzg/image/upload/v1765603839/Lot_122_option_2_facade_yckxrn.webp",
//         title: "Amber 23",
//         subtitle: "Residential Build • 2025",
//         slug: "amber-23"
//     },
//     {
//         imgDefault: "https://res.cloudinary.com/dexvxngzg/image/upload/v1764738753/Lot_11_front_view_option_1_j15rji.jpg",
//         imgHover: "https://res.cloudinary.com/dexvxngzg/image/upload/v1764738752/Lot_11_front_view_option_2_t41ont.jpg",
//         title: "Eureka 26",
//         subtitle: "Custom Home Design • 2025",
//         slug: "eureka-26"
//     },
//     {
//         imgDefault: "https://res.cloudinary.com/dexvxngzg/image/upload/v1765603841/LOT_162_front_facade_ws7wc4.webp",
//         imgHover: "https://res.cloudinary.com/dexvxngzg/image/upload/v1765603841/LOT_162_front_facade_ws7wc4.webp",
//         title: "Olive 27",
//         subtitle: "Custom Home Design • 2025",
//         slug: "olive-27"
//     },
//     {
//         imgDefault: "https://res.cloudinary.com/dexvxngzg/image/upload/v1765607256/Lot_15_front_view_option_2_z2nw1h.webp",
//         imgHover: "https://res.cloudinary.com/dexvxngzg/image/upload/v1765607256/Lot_15_front_view_option_2_z2nw1h.webp",
//         title: "Elmstone 26 option 1",
//         subtitle: "Custom Home Design • 2025",
//         slug: "elmstone-26"
//     },
//     {
//         imgDefault: "https://res.cloudinary.com/dexvxngzg/image/upload/v1765607255/Lot_15_front_view_option_1_mk0cwj.webp",
//         imgHover: "https://res.cloudinary.com/dexvxngzg/image/upload/v1765607255/Lot_15_front_view_option_1_mk0cwj.webp",
//         title: "Elmstone 26 option 2",
//         subtitle: "Custom Home Design • 2025",
//         slug: "elmstone-26"
//     }
// ];

// const ProjectSection = (props) => {
//     return (
//         <section className={props.hclass}>
//             <div className="container-fulid">

//                 {/* Section Title */}
//                 <h2
//                     className="fade_bottom"
//                     style={{
//                         fontWeight: 900,
//                         fontSize: "clamp(40px, 7vw, 90px)",
//                         lineHeight: "1.05",
//                         textAlign: "center",
//                         wordBreak: "break-word",
//                         padding: "0px 16px 47px",
//                         maxWidth: "1200px",
//                         margin: "0 auto",
//                     }}
//                 >
//                     Our Works
//                 </h2>

//                 {/* First Row */}
//                 <div className="project-wrap">
//                     {Projects2025.slice(0, 4).map((project, index) => (
//                         <div className="project-card fade_bottom" key={index}>
//                             <img src={project.imgDefault} alt={project.title} />
//                             <img src={project.imgHover} alt={project.title} />

//                             <div className="content">
//                                 <h2>
//                                     <Link
//                                         onClick={ClickHandler}
//                                         to={`/project-single/${project.slug}`}
//                                         style={{ fontWeight: 900 }}
//                                     >
//                                         {project.title}
//                                     </Link>
//                                 </h2>
//                                 <span>{project.subtitle}</span>
//                             </div>
//                         </div>
//                     ))}
//                 </div>

//                 {/* Second Row */}
//                 <div className="project-wrap" style={{ marginTop: "30px" }}>
//                     {Projects2025.slice(4, 8).map((project, index) => (
//                         <div className="project-card fade_bottom" key={index}>
//                             <img src={project.imgDefault} alt={project.title} />
//                             <img src={project.imgHover} alt={project.title} />

//                             <div className="content">
//                                 <h2>
//                                     <Link
//                                         onClick={ClickHandler}
//                                         to={`/project-single/${project.slug}`}
//                                         style={{ fontWeight: 900 }}
//                                     >
//                                         {project.title}
//                                     </Link>
//                                 </h2>
//                                 <span>{project.subtitle}</span>
//                             </div>
//                         </div>
//                     ))}
//                 </div>

//                 {/* View All Button */}
//                 <div className="project-allBtn fade_bottom">
//                     <Link onClick={ClickHandler} to="/projects" className="theme-btn">
//                         <span>See All Projects</span>
//                         <img src={Shape} alt="Arrow" />
//                     </Link>
//                 </div>

//             </div>
//         </section>
//     );
// };

// export default ProjectSection;



import React from "react";
import { Link } from "react-router-dom";
// import Shape from "../../images/right-arrow-2.svg";

const ClickHandler = () => {
  window.scrollTo(10, 0);
};

const Projects2025 = [
  {
    imgDefault:
      "https://res.cloudinary.com/dexvxngzg/image/upload/v1764738937/facade_lot_121_option_1_erzo6m.jpg",
    imgHover:
      "https://res.cloudinary.com/dexvxngzg/image/upload/v1764738934/facade_lot_121_option_2_p21ecb.jpg",
    title: "Dreamland 23",
    subtitle: "Residential Build • 2025",
    slug: "dreamland-23",
  },
  {
    imgDefault:
      "https://res.cloudinary.com/dexvxngzg/image/upload/v1765603851/lot_122_option_1_facade_hacz0z.webp",
    imgHover:
      "https://res.cloudinary.com/dexvxngzg/image/upload/v1765603839/Lot_122_option_2_facade_yckxrn.webp",
    title: "Amber 23",
    subtitle: "Residential Build • 2025",
    slug: "amber-23",
  },
  {
    imgDefault:
      "https://res.cloudinary.com/dexvxngzg/image/upload/v1764738753/Lot_11_front_view_option_1_j15rji.jpg",
    imgHover:
      "https://res.cloudinary.com/dexvxngzg/image/upload/v1764738752/Lot_11_front_view_option_2_t41ont.jpg",
    title: "Eureka 26",
    subtitle: "Custom Home Design • 2025",
    slug: "eureka-26",
  },
  {
    imgDefault:
      "https://res.cloudinary.com/dexvxngzg/image/upload/v1765603841/LOT_162_front_facade_ws7wc4.webp",
    imgHover:
      "https://res.cloudinary.com/dexvxngzg/image/upload/v1765603841/LOT_162_front_facade_ws7wc4.webp",
    title: "Olive 27",
    subtitle: "Custom Home Design • 2025",
    slug: "olive-27",
  },
  {
    imgDefault:
      "https://res.cloudinary.com/dexvxngzg/image/upload/v1765607256/Lot_15_front_view_option_2_z2nw1h.webp",
    imgHover:
      "https://res.cloudinary.com/dexvxngzg/image/upload/v1765607256/Lot_15_front_view_option_2_z2nw1h.webp",
    title: "Elmstone 26 option 1",
    subtitle: "Custom Home Design • 2025",
    slug: "elmstone-26",
  },
  {
    imgDefault:
      "https://res.cloudinary.com/dexvxngzg/image/upload/v1765607255/Lot_15_front_view_option_1_mk0cwj.webp",
    imgHover:
      "https://res.cloudinary.com/dexvxngzg/image/upload/v1765607255/Lot_15_front_view_option_1_mk0cwj.webp",
    title: "Elmstone 26 option 2",
    subtitle: "Custom Home Design • 2025",
    slug: "elmstone-26",
  },
];

const ProjectSection = (props) => {
  return (
    <section className={props.hclass}>
      <div className="container-fulid">
        <h2
          className="fade_bottom"
          style={{
            fontWeight: 900,
            fontSize: "clamp(48px, 6vw, 90px)",
            lineHeight: "1.05",
            textAlign: "center",
            padding: "0 16px 47px",
            maxWidth: "1200px",
            margin: "0 auto",
          }}
        >
          Our Works
        </h2>

        <div className="project-wrap">
          {Projects2025.slice(0, 4).map((project, index) => (
            <div className="project-card fade_bottom" key={index}>
              <img src={project.imgDefault} alt={project.title} />
              <img src={project.imgHover} alt={project.title} />

              <div className="content">
                <h2>
                  <Link
                    onClick={ClickHandler}
                    to={`/project-single/${project.slug}`}
                  >
                    {project.title}
                  </Link>
                </h2>
                {/* <span>{project.subtitle}</span> */}
              </div>
            </div>
          ))}
        </div>

        <div className="project-wrap" style={{ marginTop: "30px" }}>
          {Projects2025.slice(4, 8).map((project, index) => (
            <div className="project-card fade_bottom" key={index}>
              <img src={project.imgDefault} alt={project.title} />
              <img src={project.imgHover} alt={project.title} />

              <div className="content">
                <h2>
                  <Link
                    onClick={ClickHandler}
                    to={`/project-single/${project.slug}`}
                  >
                    {project.title}
                  </Link>
                </h2>
                {/* <span>{project.subtitle}</span> */}
              </div>
            </div>
          ))}
        </div>

        {/* <div className="project-allBtn fade_bottom">
          <Link onClick={ClickHandler} to="/projects" className="theme-btn">
            <span>See All Projects</span>
            <img src={Shape} alt="Arrow" />
          </Link>
        </div> */}
      </div>

      {/* RESPONSIVE FINAL STYLES */}
      <style>
        {`
          .project-card .content {
            position: absolute;
            left: 0;
            bottom: 0;
            z-index: 1;
            width: 100%;
            padding: 14px 18px;
            background: linear-gradient(
              to top,
              rgba(0,0,0,0.8),
              rgba(0,0,0,0.45),
              rgba(0,0,0,0)
            );
          }

          .project-card .content h2 a {
            font-size: 20px;
            line-height: 1.25;
            font-weight: 900;
          }

          .project-card .content span {
            font-size: 15px;
            line-height: 1.3;
            display: block;
          }

          /* Tablet */
          @media (max-width: 1024px) {
            .project-card .content h2 a {
              font-size: 18px;
            }

            .project-card .content span {
              font-size: 14px;
            }
          }

          /* Mobile */
          @media (max-width: 768px) {
            .project-card .content {
              padding: 12px 14px;
            }

            .project-card .content h2 a {
              font-size: 16px;
            }

            .project-card .content span {
              font-size: 13px;
            }
          }

          /* Small Mobile */
          @media (max-width: 480px) {
            .project-card .content h2 a {
              font-size: 15px;
            }

            .project-card .content span {
              font-size: 12px;
            }
          }
        `}
      </style>
    </section>
  );
};

export default ProjectSection;
